export class BreadcrumbsUrl {

  constructor(public url, public caption, public opts = {}) { }

}
